
import axiosInstance from "./AxiosInstanceMain";

export const getRulesApi=async(params={})=>{
  const res=await axiosInstance.get( "/lead-assignment/all", { params } );
  return res.data;
};

export const createRuleApi=async(data)=>{
  const res=await axiosInstance.post( "/lead-assignment/create", data );
  return res.data;
};

export const toggleRuleApi=async(id)=>{
  const res=await axiosInstance.patch( `/lead-assignment/toggle/${id}` );
  return res.data;
};

export const updateRuleApi=async(id,data)=>{
const res=await axiosInstance.post(`/lead-assignment/update/${id}`,data);
return res.data;
};

export const getRuleUsersApi=async(params={})=>{
  const res=await axiosInstance.get( "/lead-assignment/rule-users", { params } );
  return res;
};

export const pauseUserApi = async (ruleId, data) => {
  const res = await axiosInstance.post(`/lead-assignment/pause-user/${ruleId}`, data);
  return res.data;
};

export const resumeUserApi = async (ruleId, data) => {
  const res = await axiosInstance.post(`/lead-assignment/resume-user/${ruleId}`, data);
  return res.data;
};

export const handleUserChangesApi = async (ruleId, data) => {
  const res = await axiosInstance.post(`/lead-assignment/handle-user-changes/${ruleId}`, data);
  return res.data;
};

export const getRuleLogsApi = async (ruleId, params = {}) => {
  const res = await axiosInstance.get(ruleId ? `/lead-assignment/logs/${ruleId}` : "/lead-assignment/logs", { params });
  return res.data;
};